
import { DiaryEntry } from "@/utils/diary/types";
import EntryTags from "./footer/EntryTags";
import FooterActions from "./footer/FooterActions";

interface EntryCardFooterProps {
  entry: DiaryEntry;
  readOnly: boolean;
  onDelete: () => void;
}

const EntryCardFooter = ({ entry, readOnly, onDelete }: EntryCardFooterProps) => {
  // Ensure activities and milestones are arrays, even if they're undefined
  const activities = entry.activities || [];
  const milestones = entry.milestones || [];

  return (
    <div className="pt-3 flex justify-between">
      <EntryTags activities={activities} milestones={milestones} />
      
      {!readOnly && (
        <FooterActions entryId={entry.id} onDelete={onDelete} />
      )}
    </div>
  );
};

export default EntryCardFooter;
